import React from 'react';
import {Column, ColumnConfig} from '@ant-design/plots';

type Legend = {
    name: string;
}

type ColumnChartProps = {
    data: Record<string, any>[];
    config: (data: Record<string, any>[], colors: string[], legendLabels: any[], max: number, min: number) => ColumnConfig;
    legends: Legend[];
    max: number;
    min: number;
}

const ColumnChart = ({
    data,
    config,
    legends,
    max,
    min
}: ColumnChartProps) => {
    const colors = [
        '#dc3832',
        '#f0a841',
        '#e36d38',
        '#00abe9',
        '#626681',
        '#EB4185'
    ];

    const formatLegendLabel = (name: string, index: number) => ({
        id: `legend-${index}`,
        name: name,
        marker: {
            symbol: 'circle',
            style: {
                fill: colors[index],
                r: 5
            }
        }
    });

    const legendLabels = legends.map(({ name }, index) =>
        formatLegendLabel(name, index)
    );

    return (
        <Column {...config(data, colors, legendLabels, max, min)}/>
    )
}

export default ColumnChart;
